export default __webpack_public_path__ + "static/media/logoNoBackground.5a1b72f2.png";